
import { Component, Prop, Vue } from "vue-property-decorator";

@Component({
  name: "icon-edit",
  components: {},
})
export default class IconEdit extends Vue {
  @Prop() public width!: number;
  @Prop() public height!: number;
  @Prop() public color!: string;

  constructor() {
    super();
  }
}
